<template>
  <v-select
    v-bind="{ ...selectProps }"
    autocomplete="nope"
    :class="getValidationClass"
    @input="onInput"
    @keypress.native.enter.prevent
  >
    <template slot="selected-option" slot-scope="option">
      <slot name="selected-option" :option="option" />
    </template>

    <template slot="option" slot-scope="option">
      <slot name="option" :option="option">
        {{ option[selectProps.label] }}
      </slot>
    </template>
  </v-select>
</template>

<script>
import { getValidationClass } from '@/stateReducers'

export default {
  name: 'Select',
  props: {
    selectProps: {
      type: Object,
      default: () => ({})
    },
    onInput: {
      type: Function,
      default: () => ({})
    },
    onSearch: {
      type: Function,
      default: null
    },
    validation: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    getValidationClass() {
      return getValidationClass({ validation: this.validation })
    }
  }
}
</script>
